import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { constants } from '@shared/constants';
import { authFeature } from '@store';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  isAuthenticated$ = this.store.select(authFeature.selectIsLoggedIn);

  constructor(
    private router: Router,
    private store: Store,
  ) {}

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.isAuthenticated$.pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          return true;
        }

        this.router.navigate([constants.AUTH_ROUTE], this.getReturnUrl(state.url));

        return false;
      }),
    );
  }

  getReturnUrl(url?: string): NavigationExtras | undefined {
    if (!url || url === constants.HOME_ROUTE) {
      return;
    }

    return {
      queryParams: {
        returnUrl: url,
      },
    };
  }
}
